import React from 'react';
import PropTypes from 'prop-types';

import '../Questionnaire.scss';

/**
 * Drop-in replacement for ui-components CarouselArrow.
 *
 * Renders the same two-div structure the library uses (desktop absolute + mobile block)
 * so positioning is pixel-identical. The inner element is a native <button> instead of
 * a library button, so Tab / Enter / Space and :focus-visible all work without any JS.
 *
 * display:none on the hidden viewport variant removes it from the tab order automatically,
 * so there is no double-Tab stop.
 */
const AccessibleCarouselArrow = ({ direction, hidden, onActivate }) => {
  const isLeft = direction === 'left';
  const label = isLeft ? 'Previous question' : 'Next question';
  const desktopPosClass = isLeft ? 'left-1 pr1' : 'right-1 pl1';

  const button = (
    <button
      type="button"
      className="questionnaire-carousel-arrow br-pill pa0 vertical-center h3 w3 bottom-0 top-0 pointer bg-primary white bn"
      hidden={hidden}
      aria-label={label}
      onClick={hidden ? undefined : onActivate}
    >
      <i className={`fas fa-3x fa-angle-${direction}`} aria-hidden="true" />
    </button>
  );

  return (
    <>
      {/* Desktop: absolutely positioned at left-1 / right-1, hidden on small screens */}
      <div className={`dn dn-m db-l absolute ${desktopPosClass}`}>
        {button}
      </div>
      {/* Mobile: block in normal flow, hidden on large screens */}
      <div className="db dn-l">
        {button}
      </div>
    </>
  );
};

AccessibleCarouselArrow.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']).isRequired,
  hidden: PropTypes.bool,
  onActivate: PropTypes.func.isRequired,
};

AccessibleCarouselArrow.defaultProps = {
  hidden: false,
};

export default AccessibleCarouselArrow;
